
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import './landing.scss';

import { useConfig } from '../../hooks';


import GeolocationButton from '../GeolocationButton';
import StageGoogleMapsAutoCompleteForm from '../StageGoogleMapsAutoCompleteForm';

function Landing({ showWorldMap, onLocationChange }) {
  const { t } = useTranslation('dealers');
  const { config } = useConfig();

  function handleLocate(result) {
    onLocationChange({
      ...result,
      countryCode: result.countryCode || config.countryCode,
    });
  }

  function handleLocationChange(result) {
    onLocationChange(result);
  }

  return (
    <div className="dealers-landing">
      <h1>{t('Find the nearest Nokian Tyres dealer')}</h1>

      <div className="dealers-landing-content">
        <p className="copy">{t('Landing copy')}</p>

        <div className="landing-actions">
          <GeolocationButton className="dealers-button dealers-landing-geolocation" onLocate={handleLocate} />

          <>
            <h4>{t('Or')}</h4>

            <StageGoogleMapsAutoCompleteForm type="landing" initialValue={''} onUserLocationChange={handleLocationChange} />
          </>
        </div>

        {showWorldMap && (
          <img
            className="dealers-dot-map"
            src="https://nokiantyres.studio.crasman.cloud/pub/web/assets/dotted-map.svg"
            alt="Nokian Tyres"
            width="266"
            height="150"
          />
        )}
      </div>
    </div>
  );
}

Landing.propTypes = {
  showWorldMap: PropTypes.bool,
  onLocationChange: PropTypes.func,
};

export default Landing;
